export const Mode = {
  TOP: 'top',
  BOTTOM: 'bottom',
} as const;

export type Mode = Union<typeof Mode>;

export const enum State {
  ORIGINAL,
  RELEASED,
  FIXED,
}
